export const ChiroFormType = {
    DRAFT: "Draft",
    SUBMITTED: "Submitted"
};